'use client';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import styled from '@emotion/styled';
const StyledSelectedText = styled('span')(({ theme }) => ({
    color: theme.tokens.FuelColorTextPrimary,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
}));
export const getSelectedText = (args) => {
    if (args.selected?.length === 1) {
        const option = args.options?.find(({ value }) => value === args.selected?.[0]);
        return option ? (_jsxs(_Fragment, { children: [option.startIcon, _jsx(StyledSelectedText, { children: option.children })] })) : null;
    }
    if (args.selected && args.selected.length > 1) {
        return (_jsx(StyledSelectedText, { children: `${args.selected.length} items selected` }));
    }
    if (args.placeholder) {
        return args.placeholder;
    }
    return `Select ${args.multiple ? 'items' : 'an item'}`;
};
